import { lazy } from "react";

const AppRoutes = [
  {
    id: "404",
    name: "404",
    path: "*",
    component: lazy(() => import("@/pages/404")),
    type: "open",
    props: {},
  },
  {
    id: "notFound",
    name: "Not Found",
    path: "/404",
    component: lazy(() => import("@/pages/404")),
    type: "open",
    props: {},
  },
  {
    id: "home",
    name: "Home",
    path: "/",
    component: lazy(() => import("@/pages/home")),
    type: "open",
    props: {},
  },

  // USER AUTH ROUTES //
  {
    id: "createPassword",
    name: "Create Password",
    path: "/create-password",
    component: lazy(() => import("@/pages/user/auth/create-pass")),
    type: "open",
    props: {},
  },
  {
    id: "thankYou",
    name: "Thank You",
    path: "/thank-you",
    component: lazy(() => import("@/pages/user/auth/thank-you")),
    type: "open",
    props: {},
  },
  // USER AUTH ROUTES //

  // USER ROUTES //
  {
    id: "listing",
    name: "CListing",
    path: "/free-listing",
    component: lazy(() => import("@/pages/user/listing")),
    type: "open",
    props: {},
  },
  {
    id: "listing",
    name: "CListing",
    path: "/buy-requirement",
    component: lazy(
      () => import("@/pages/user/dashboard/pages/buyer/request/module")
    ),
    type: "open",
    props: {},
  },
  // USER ROUTES //

  // COMPANY ROUTES //
  {
    id: "companyListing",
    name: "Company Listing",
    path: "/companies/*",
    component: lazy(() => import("@/pages/company/listing")),
    type: "open",
    props: {},
  },
  {
    id: "companyDetails",
    name: "Company Details",
    path: "/company/details",
    component: lazy(() => import("@/pages/company/details")),
    type: "open",
    props: {},
  },
  {
    id: "companyWebsite",
    name: "Company Website",
    path: "/company/website/*",
    component: lazy(() => import("@/pages/company/website")),
    type: "open",
    props: {},
  },
  {
    id: "companyCompare",
    name: "Company Compare",
    path: "/compare/*",
    component: lazy(() => import("@/pages/company/compare")),
    type: "open",
    props: {},
  },
  {
    id: "companyCompare",
    name: "Company Compare",
    path: "company/compare/details",
    component: lazy(() => import("@/pages/company/compare/details")),
    type: "open",
    props: {},
  },
  // COMPANY ROUTES //
  {
    id: "productDetails",
    name: "product Details",
    path: "/products/*",
    component: lazy(() => import("@/pages/products")),
    type: "open",
    props: {},
  },
  {
    id: "serviceDetails",
    name: "service Details",
    path: "/services/*",
    component: lazy(() => import("@/pages/services")),
    type: "open",
    props: {},
  },
  {
    id: "categoryDetails",
    name: "category Details",
    path: "/categories",
    component: lazy(() => import("@/pages/categories")),
    type: "open",
    props: {},
  },
  {
    id: "Seller",
    name: "Seller",
    path: "/seller/*",
    component: lazy(() => import("@/pages/seller")),
    type: "open",
    props: {},
  },
  {
    id: "Buyer",
    name: "Buyer",
    path: "/buyer/*",
    component: lazy(() => import("@/pages/buyer")),
    type: "open",
    props: {},
  },
  {
    id: "Compare",
    name: "compare",
    path: "/compare/details",
    component: lazy(() => import("@/pages/company/compare/details")),
    type: "open",
    props: {},
  },
];

export default AppRoutes;
